import { t } from "i18next";

import CorporationGlobalSearchMemberList from "./CorporationGlobalSearchList";

import { useCorpGlobalSearchListControllerContext } from "../../Controller";

const MainPage = () => {
  const {
    corpGlobalList,
    searchParams,
    pagination,
    isLoadingGetCorporationGlobalList,
    onClickRow,
    onSort,
    onChangePage,
    onChangePerPage,
    onFilter,
    onSearch,
  } = useCorpGlobalSearchListControllerContext();

  return (
    <CorporationGlobalSearchMemberList
      records={corpGlobalList}
      sort={searchParams.sort}
      onSort={onSort}
      pagination={pagination}
      loading={isLoadingGetCorporationGlobalList}
      onChangePage={onChangePage}
      onChangePerPage={onChangePerPage}
      onFilter={onFilter}
      onSearch={onSearch}
      title={t("members")}
      key="idUnique"
      onRowClick={onClickRow}
      keyId="idUnique"
      filter={searchParams.filter}
    />
  );
};
export default MainPage;
